import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { changeStep } from 'store/modules';
import { withWizard } from 'containers';
import { ContractWrapper } from './style';
import Confirmation from './confirmation';
import ExpirationDate from './expirationDate';
import Payment from './payment';

export default function FinanceWizard({
  navigateBack: parentNavigateBack,
  navigateForward: parentNavigateForward,
  currentStep: parentCurrentStep,
}) {
  const theme = useContext(ThemeContext);
  const dispatch = useDispatch();
  const { financeInfo, basicInfo, solutionInfo } = useSelector((state) => state.subscription);
  const { expirationDate, payment } = financeInfo || {};

  const onCancel = () => {
    parentNavigateBack();
  };

  const navigateBackOnCancel = ({ navigateBack }) => () => {
    navigateBack();
  };

  const onCompleted = (values) => {
    parentNavigateForward(values);
  };

  const onValuesChanged = ({ values, currentStep }) => {
    if (values) {
      dispatch(
        changeStep({
          step: 'financeInfo',
          currentStep,
          parentCurrentStep,
          [values.childStep]: values.formValues[values.childStep],
        }),
      );
    }
  };

  function onSubmit({ navigateForward, childStep }) {
    return (values) => navigateForward({ childStep, formValues: values });
  }

  const steps = [
    {
      content: (props) => (
        <Confirmation
          {...props}
          initialValues={{ basicInfo, solutionInfo }}
          onCancel={onCancel}
          onSubmit={onSubmit({ ...props, childStep: 'confirmation' })}
        />
      ),
    },
    {
      content: (props) => (
        <ExpirationDate
          {...props}
          initialValues={expirationDate}
          onCancel={navigateBackOnCancel(props)}
          onSubmit={onSubmit({ ...props, childStep: 'expirationDate' })}
        />
      ),
    },
    {
      content: (props) => (
        <Payment
          {...props}
          initialValues={payment}
          onCancel={navigateBackOnCancel(props)}
          onSubmit={onSubmit({ ...props, childStep: 'payment' })}
        />
      ),
    },
  ];

  return withWizard({
    steps,
    theme,
    onValuesChanged,
    onCompleted,
  })(({ children }) => <ContractWrapper>{children}</ContractWrapper>);
}
